import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from '../../../../swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '../richText'
import {CardIconColors} from '@primer/react-brand'
import {PrimerComponentLabelSchema} from './primerComponentLabel'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentCardSchema = buildEntrySchemaFor('primerComponentCard', {
  fields: z.lazy(() =>
    z.object({
      href: z.string(),
      align: z.enum(['start', 'center']).optional(),
      label: safeOptional(z.union([z.string(), PrimerComponentLabelSchema])),
      heading: z.string().optional(),
      headingRich: safeOptional(RichTextSchema),
      headingLevel: z.enum(['h2', 'h3', 'h4', 'h5', 'h6']).optional(),
      description: safeOptional(RichTextSchema),
      ctaText: z.string().optional(),
      icon: z.string().optional(),
      iconColor: z.enum(CardIconColors).optional(),
      iconBackground: z.boolean().optional(),
      variant: z.enum(['default', 'minimal']).optional(),
      image: safeOptional(AssetSchema),
      hasBorder: z.boolean().optional(),
    }),
  ),
})

export type PrimerComponentCard = z.infer<typeof PrimerComponentCardSchema>
